/**
 * `45` — *to {something, desiredStatusValue}*. Pairs with trigger `53`.
 *
 * Observed inbound fields (`discovery/automations/api/catalog.md` §block census, and the
 * rawNodes of recipe `13964` behind automation 11843871): `boardId`, `columnId`,
 * `actualStatusValue` and `desiredStatusValue`. Only the last is configured — 17 rows, all
 * `{"index": n}`; `columnId` and `actualStatusValue` are wired to the trigger.
 *
 * Unlike `1838` it compares the **trigger-carried** value, not a live re-read: its inbound
 * wiring is `sourceType: node_results` on the trigger's `columnValue`. That is not an
 * assumption — the wiring proves it (`specs/M6-A1` §5.3, `specs/M6-A3` §11).
 */
import { z } from 'zod';
import { defineCondition } from '../block.js';
import { labelValueMatches, labelValueSchema } from '../values.js';
import { NEW_STATUS_OUTPUTS, triggerNumberOutput } from './node-results.js';
export const toValueParams = z.object({ desiredStatusValue: labelValueSchema });
export const toValueCondition = defineCondition({
    id: '45',
    kind: 'condition',
    app: 'monday',
    sentencePartial: 'to {something, desiredStatusValue}',
    paramsSchema: toValueParams,
    references: () => [],
    async evaluate(context, params) {
        return labelValueMatches(params.desiredStatusValue, triggerNumberOutput(context, NEW_STATUS_OUTPUTS));
    },
});
//# sourceMappingURL=45.js.map